import { defineStore } from "pinia";
import { Worldview, WorldviewLocation } from "@/types/entity";
import {
  createOneWorldview,
  deleteOneWorldview,
  readWorldviewPage,
  updateOneWorldview,
  createOneWorldviewLocation,
  updateOneWorldviewLocation,
  deleteOneWorldviewLocation,
  readWorldviewByUuid,
} from "@/apis/user";

export const useWorldview = defineStore("worldview", {
  state: () => {
    return {
      worldviewList: [] as Worldview[],
    };
  },
  getters: {
    worldviewMap(state) {
      return state.worldviewList.reduce((acc, worldview) => {
        acc[worldview.id] = worldview;
        return acc;
      }, {} as Record<number, Worldview>);
    },
  },
  actions: {
    async getWorldviewList(force = false) {
      if (!force && this.worldviewList.length > 0) {
        return this.worldviewList;
      }
      const res = await readWorldviewPage();
      this.worldviewList = res.page.data;
    },
    async getWorldviewByUuid(uuid: string) {
      const res = await readWorldviewByUuid(uuid);
      return res.item;
    },
    isMyWorldview(uuid: string): boolean {
      return this.worldviewList.some((worldview) => worldview.uuid === uuid);
    },
    isMyWorldviewById(id: number): boolean {
      return this.worldviewList.some((worldview) => worldview.id === id);
    },
    async updateWorldview(id: number, params: Partial<Worldview>) {
      const worldview = this.worldviewMap[id];
      if (!worldview) {
        throw new Error("Worldview not found");
      }
      Object.keys(params).forEach((key) => {
        worldview[key] = params[key];
      });
      await updateOneWorldview(id, params);
    },
    async createWorldview(name: string, description: string = "") {
      const res = await createOneWorldview({ name, description });
      this.worldviewList.push(res.item);
      return res.item;
    },
    async deleteWorldview(id: number) {
      await deleteOneWorldview(id);
      this.worldviewList = this.worldviewList.filter(
        (worldview) => worldview.id !== id
      );
    },
    async createWorldviewLocation(
      worldviewId: number,
      name: string,
      description: string = ""
    ) {
      const res = await createOneWorldviewLocation({
        worldviewId,
        name,
        description,
      });
      this.worldviewMap[worldviewId].locationzz?.push(res.item);
      return res.item;
    },
    async updateWorldviewLocation(
      id: number,
      params: Partial<WorldviewLocation>
    ) {
      const res = await updateOneWorldviewLocation(id, params);
      return res.item;
    },
    async deleteWorldviewLocation(id: number, worldviewId: number) {
      await deleteOneWorldviewLocation(id);
      this.worldviewMap[worldviewId].locationzz = this.worldviewMap[
        worldviewId
      ].locationzz?.filter((worldviewLocation) => worldviewLocation.id !== id);
    },
  },
});
